import api from '../services/api';
import companiaService, { type Compania } from '../services/companiaService';

async function blobToPngDataUrl(blob: Blob): Promise<string | null> {
  if (!blob.size || (blob.type && blob.type.includes('json'))) return null;
  try {
    const bmp = await createImageBitmap(blob);
    const canvas = document.createElement('canvas');
    canvas.width = bmp.width;
    canvas.height = bmp.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      bmp.close?.();
      return null;
    }
    ctx.drawImage(bmp, 0, 0);
    bmp.close?.();
    return canvas.toDataURL('image/png');
  } catch {
    return null;
  }
}

async function fetchLogoBlobViaApi(path: string): Promise<string | null> {
  try {
    const { data } = await api.get<Blob>(path, { responseType: 'blob' });
    const blob = data instanceof Blob ? data : new Blob([data as BlobPart]);
    return blobToPngDataUrl(blob);
  } catch {
    return null;
  }
}

/** Logo vía API (archivo subido o URL remota en el servidor). */
export async function fetchLogoPngDataUrl(idCompania: string): Promise<string | null> {
  const path = `/api/Compañias/${encodeURIComponent(idCompania)}/logo-contenido`;
  return fetchLogoBlobViaApi(path);
}

export async function fetchCompaniaParaPdf(): Promise<Compania | null> {
  try {
    const list = await companiaService.getCompanias({ pageNumber: 1, pageSize: 1 });
    if (!list.length) return null;
    return await companiaService.getCompania(list[0].idCompania);
  } catch {
    return null;
  }
}

function normalizarTextoCompania(s: string | undefined | null): string {
  if (s == null || s === '') return '';
  return String(s).replace(/\s+/g, ' ').trim();
}

export function lineasDatosCompania(c: Compania): string[] {
  const out: string[] = [];
  const nombre = normalizarTextoCompania(c.nombre);
  if (nombre) out.push(nombre);
  const cpLoc = [normalizarTextoCompania(c.cp), normalizarTextoCompania(c.localidad)]
    .filter(Boolean)
    .join(' ');
  const dom = [normalizarTextoCompania(c.domicilio), cpLoc].filter(Boolean).join(' — ');
  if (dom) out.push(dom);
  const provN = normalizarTextoCompania(c.provincia);
  let paisN = normalizarTextoCompania(c.pais);
  if (paisN === '.' || paisN === '-') paisN = '';
  const loc = [provN, paisN].filter(Boolean).join(' · ');
  if (loc) out.push(loc);
  const cuit = normalizarTextoCompania(c.cuit);
  if (cuit) out.push(`CUIT: ${cuit}`);
  const cond = normalizarTextoCompania(c.condIva);
  if (cond) out.push(cond);
  const tel = normalizarTextoCompania(c.telefono1);
  if (tel) out.push(`Tel: ${tel}`);
  const mail = normalizarTextoCompania(c.mail1);
  if (mail) out.push(mail);
  return out.slice(0, 8);
}
